module.exports = __webpack_public_path__ + "static/media/user-alt-slash.cc10d16d.svg";